export default __webpack_public_path__ + "c7ecfe59439b5fd23924fd206cf2fded.svg";